export const svg = '/assets/illustrations/illustration_empty_content.svg';
